import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyBottomBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      // Appear after 600px scroll
      const pastThreshold = scrollY > 600;
      // Disappear within 300px of bottom
      const nearBottom = documentHeight - (scrollY + windowHeight) < 300;
      setIsVisible(pastThreshold && !nearBottom);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll(); // Check initial state
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-521">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 w-full z-[999] bg-primary-dark/95 backdrop-blur-[20px] border-t border-gold-accent/30 px-[20px] md:px-[32px] py-[14px]" data-id="element-522">
          <div className="max-w-[1200px] mx-auto flex justify-between items-center" data-id="element-523">
            <div className="hidden md:block font-sans text-[14px] text-cream-light/60" data-id="element-524">
              😰 Still feeling the Sunday dread?
            </div>

            <div className="font-sans text-[15px] font-bold text-gold-accent" data-id="element-525">
              The system that ends it — $9.99
            </div>

            <button onClick={() => document.getElementById('pricing-section')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-gold-accent text-primary-dark px-[24px] py-[10px] font-sans text-[13px] font-bold uppercase rounded-[4px] hover:bg-gold-hover transition-colors" data-id="element-526">
              GET THE SYSTEM →
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}